module.exports = __webpack_public_path__ + "static/media/settings-logout.5c28317f.png";